/* eslint-disable jsx-a11y/media-has-caption */
import {VideoType as VideoType} from '~/features/shared';

interface VideoProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  video: VideoType;
}

export function Video({video, ...props}: VideoProps) {
  const mp4 = video.sources.filter((s) => s.mimeType === 'video/mp4');
  const src = mp4.length >= 2 ? mp4[1] : mp4[0];

  return (
    <video
      onContextMenu={(e) => e.preventDefault()}
      controlsList="nodownload"
      {...props}
    >
      <source src={src.url} type={src.mimeType} />
    </video>
  );
}
